





import { Component, Vue } from 'vue-property-decorator';
import FooterMenu from '@/components/FooterMenu.vue';

@Component({
  components: {
  },
})
export default class App extends Vue {
    public mounted() {
        // describing the issue: https://github.com/ionic-team/capacitor/issues/814
        // fix from: https://github.com/apache/cordova-ios/issues/417
        // This fixes the issue where you on iOS can scroll the "front-end" without scrolling the actual graphical design,
        // thus making you unable to hit anything (easy testable by using text fields)
        let timeout: number;
        function blurEvent() {
            timeout = setTimeout (() => {
                window.scrollTo(0, 0);
            }, 50);
        }

        function focusEvent() {
            clearTimeout (timeout);
        }

        window.addEventListener('scroll', () => {
            const inputfields = document.querySelectorAll('input');
            for (const inp of inputfields) {
                inp.removeEventListener('blur', blurEvent);
                inp.addEventListener('blur', blurEvent);
                inp.removeEventListener('focus', focusEvent);
                inp.addEventListener('focus', focusEvent);
            }
        });
    }
}


